module.exports = __webpack_public_path__ + "img/mC-tips4.8564e49f.png";